export default function () {
    return {
        submenuActive: false,
        activateSubmenu() {
            this.submenuOpen = true; //inherit from mobileMenu
            this.submenuActive = true;
        },
        init() {
            this.$watch("submenuOpen", (val) => {
                if (!val) {
                    this.submenuActive = false;
                }
            });
        },

        //elements
        submenuOpenButton: {
            ["@click"]() {
                this.activateSubmenu();
            },
            ["@keydown.enter"]() {
                this.activateSubmenu();
            },
            ["@keydown.space"]() {
                this.activateSubmenu();
            },
        },
        backButton: {
            ["@click"]() {
                this.closeSubmenu();
            },
            ["@keydown.enter"]() {
                this.closeSubmenu();
            },
            ["@keydown.space"]() {
                this.closeSubmenu();
            },
        },
        submenu: {
            ["x-transition.leave.duration.500ms"]: true,
            ["x-show"]() {
                return this.submenuActive;
            },
            ["x-trap.noautofocus.inert"]() {
                return this.submenuActive;
            },
        },
    };
}
